import React from "react";
import { getInceptionUserServiceColumns, InceptionUserServiceSection } from "./inception";
import { UserServiceDefinition, UserServiceFormSectionProps } from "./types";

const userServiceDefinitions: Array<UserServiceDefinition> = [
    {
        key: "inception",
        FormSection: InceptionUserServiceSection,
        getColumns: getInceptionUserServiceColumns
    }
];

export const UserServiceFormSections = (props: UserServiceFormSectionProps) => {
    return (
        <>
            {userServiceDefinitions.map(({ key, FormSection }) => (
                FormSection ? <FormSection key={key} {...props} /> : null
            ))}
        </>
    );
};

export const getUserServiceColumns = (users: Array<any>) => {
    return userServiceDefinitions.flatMap(({ getColumns }) => {
        return getColumns ? getColumns(users) : [];
    });
};
